<template>
  <div>
    <!--面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>商品分类</el-breadcrumb-item>
    </el-breadcrumb>
    <!--卡片视图-->
    <el-card>
      <el-row>
        <el-col>
          <el-button type="primary" @click="showAddDialog">添加分类</el-button>
        </el-col>
      </el-row>
      <!--表格区域-->
      <tree-table
        class="treeTable"
        :data="cateList"
        :columns="columns"
        :selection-type="false"
        :expand-type="false"
        show-index
        index-text="#"
        border
        :show-row-hover="false"
      >
        <!--是否有效-->
        <template slot="isok" slot-scope="scope">
          <i class="el-icon-error" v-if="scope.row.cat_deleted === true" style="color:red"></i>
          <i class="el-icon-success" v-else style="color:lightgreen"></i>
        </template>
        <!--排序-->
        <template slot="rights" slot-scope="scope">
          <el-tag v-if="scope.row.cat_level==0" size="mini">一级</el-tag>
          <el-tag v-else-if="scope.row.cat_level==1" type="success" size="mini">二级</el-tag>
          <el-tag v-else type="warning" size="mini">三级</el-tag>
        </template>
        <!--操作-->
        <template slot="opt" slot-scope="scope">
          <!--编辑角色按钮-->
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            @click="editCateById(scope.row)"
          >编辑</el-button>
          <!--删除角色按钮-->
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="removeCateById(scope.row.cat_id)"
          >删除</el-button>
        </template>
      </tree-table>
      <!--分页区域-->
      <!--分页区域-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[1, 2, 5, 10]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!--添加分类-->
    <el-dialog
      title="添加分类"
      :visible.sync="addDialogVisible"
      @close="addCateDialogClose"
      width="50%"
    >
      <!--添加分类的表单-->
      <el-form
        :model="addCateForm"
        :rules="addCateFormRules"
        ref="addCateFormRef"
        label-width="100px"
      >
        <el-form-item label="分类名称：" prop="cat_name">
          <el-input v-model="addCateForm.cat_name"></el-input>
        </el-form-item>
        <!--级联选择器-->
        <el-form-item label="父级分类：">
          <el-cascader
            clearable
            v-model="selectedKeys"
            :options="parentCateList"
            :props="cascaderProps"
            @change="parentCateChange"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCate()">确 定</el-button>
      </span>
    </el-dialog>

    <!--编辑分类-->
    <el-dialog title="编辑分类" @close="editDialogClose" :visible.sync="editDialogVisible" width="50%">
      <el-form
        :model="editCateFrom"
        :rules="editCateFormReditules"
        ref="editCateFormRef"
        label-width="100px"
      >
        <el-form-item label="活动名称" prop="cat_name">
          <el-input v-model="editCateFrom.cat_name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editFormOk()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 查询商品分类列表的条件
      queryInfo: {
        type: 3,
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 5
      },
      // 所有商品分类
      cateList: [],
      // 总数据条数
      total: 0,
      // 为table指定列的定义
      columns: [
        {
          label: '分类名称',
          prop: 'cat_name'
        },
        {
          label: '是否有效',
          // 将当前列定义成模板列
          type: 'template',
          // 这一列使用的模板昵称
          template: 'isok'
        },
        {
          label: '排序',
          // 将当前列定义成模板列
          type: 'template',
          // 这一列使用的模板昵称
          template: 'rights'
        },
        {
          label: '操作',
          // 将当前列定义成模板列
          type: 'template',
          // 这一列使用的模板昵称
          template: 'opt'
        }
      ],
      // 添加分类对话框的开关
      addDialogVisible: false,
      // 添加分类的表单对象
      addCateForm: {
        // 将要添加的分类名称
        cat_name: '',
        // 父级分类id 默认一级
        cat_pid: 0,
        // 将要添加的分类等级 默认一级
        cat_level: 0
      },
      // 添加分类表单的验证规则
      addCateFormRules: {
        cat_name: [
          {
            required: true,
            message: '请输入分类名称',
            trigger: 'blur'
          }
        ]
      },
      // 父级分类数据列表
      parentCateList: [],
      // 级联选择器配置对象
      cascaderProps: {
        expandTrigger: 'hover',
        value: 'cat_id',
        label: 'cat_name',
        children: 'children',
        checkStrictly: true
      },
      // 级联选择器选中的值
      selectedKeys: [],
      // 控制编辑分类对话框的开关
      editDialogVisible: false,
      // 编辑对话框的数据
      editCateFrom: {
        cat_name: '',
        id: 0
      },
      // 编辑表单的验证规则
      editCateFormReditules: {
        cat_name: [
          {
            required: true,
            message: '请输入分类名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    this.getCateList()
  },
  methods: {
    // 获取商品信息
    async getCateList() {
      const { data: res } = await this.$http.get('categories', {
        params: this.queryInfo
      })
      if (res.meta.status !== 200) {
        return this.$message.error('获取商品分类失败')
      }
      // 把数据列表赋值给
      this.cateList = res.data.result
      // 为总数据条数赋值
      this.total = res.data.total
    },
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getCateList()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getCateList()
    },
    // 点击添加分类按钮
    showAddDialog() {
      // 先获取父级分类的数据列表
      this.getParentCateList()
      // 展示对话框
      this.addDialogVisible = true
    },
    // 获取父级分类的数据列表
    async getParentCateList() {
      const { data: res } = await this.$http.get('categories', {
        params: { type: 2 }
      })
      if (res.meta.status !== 200) {
        return this.$message.error('获取父级分类的数据列表失败')
      }
      this.parentCateList = res.data
    },
    // 级联选择器选中的值发生变化
    parentCateChange() {
      if (this.selectedKeys.length > 0) {
        this.addCateForm.cat_pid = this.selectedKeys[this.selectedKeys.length - 1]
        this.addCateForm.cat_level = this.selectedKeys.length
        return 0
      } else {
        this.addCateForm.cat_pid = 0
        this.addCateForm.cat_level = 0
      }
    },
    // 点击按钮，添加分类
    addCate() {
      this.$refs.addCateFormRef.validate(async valid => {
        if (!valid) return
        // 发起添加分类的请求
        const { data: res } = await this.$http.post(
          'categories',
          this.addCateForm
        )
        if (res.meta.status !== 201) {
          return this.$message.error('添加分类失败')
        }
        this.getCateList()
        this.$message.success('添加分类成功')
        this.addDialogVisible = false
      })
    },
    // 关闭添加分类对话框,重置表单数据
    addCateDialogClose() {
      this.$refs.addCateFormRef.resetFields()
      this.selectedKeys = []
      this.addCateForm.cat_pid = 0
      this.addCateForm.cat_level = 0
    },
    // 根据id编辑分类名称
    editCateById(cate) {
      this.editDialogVisible = true
      this.editCateFrom.cat_name = cate.cat_name
      this.editCateFrom.id = cate.cat_id
    },
    // 关闭编辑分类对话框时触发
    editDialogClose() {
      this.$refs.editCateFormRef.resetFields()
    },
    // 点击编辑对话框确认
    editFormOk() {
      this.$refs.editCateFormRef.validate(async valid => {
        if (!valid) return
        // 发起编辑分类的请求
        const { data: res } = await this.$http.put(
          'categories/' + this.editCateFrom.id,
          { cat_name: this.editCateFrom.cat_name }
        )
        if (res.meta.status !== 200) {
          return this.$message.error('编辑分类失败')
        }
        this.getCateList()
        this.$message.success('编辑分类成功')
        this.editDialogVisible = false
      })
    },
    // 根据id删除分类名称
    async removeCateById(id) {
      const confirmResult = await this.$confirm(
        '此操作将永久删除该分类, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      // 如果用户点击了确认，则返回字符串 confirm
      // 如果用户点击了取消，则返回字符串 cancle
      // console.log(confirmResult)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.delete('categories/' + id)
      if (res.meta.status !== 200) {
        return this.$message.error('删除该分类失败')
      }
      this.$message.success('该分类已删除')
      this.getCateList()
    }
  }
}
</script>

<style lang="less" scoped>
.treeTable {
  margin-top: 15px;
}
.el-cascader {
  width: 100%;
}
</style>
